import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MoveBreadcrumbService } from './moveBreadcrumb.service';

@Component({
    selector: 'move-breadcrumb',
    templateUrl: './moveBreadcrumb.component.html',
    styleUrls: ['./moveBreadcrumb.component.css'],
})
export class MoveBreadcrumbComponent {
    @Input() path: Array<any> = [];
    @Input() showBreadcrumb: Array<any> = [];
    @Output() breadcrumbClicked = new EventEmitter<number>();
    @Output() allClicked = new EventEmitter<void>();

    breadcrumbs: Array<any> = [];

    constructor(private moveBreadcrumbService: MoveBreadcrumbService) {}

    ngOnInit() {
        this.moveBreadcrumbService.currentBreadcrumbs.subscribe((breadcrumbs) => {
            this.breadcrumbs = breadcrumbs;
        });
    }

    onBreadcrumbClick(index: number) {
        this.breadcrumbClicked.emit(index);
    }

    onAllClick() {
        this.breadcrumbs = [];
        this.moveBreadcrumbService.updateBreadcrumbs(this.breadcrumbs);
        this.allClicked.emit();
    }
}
